import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import ModalOverlay from "../../components/ModalOverlay";

import heroMobileImage from '../../images/articles/PO0131005_WF_BRAND_2HFY24_ISF_SepUpdate14_LP_767x577.jpg';
import heroDesktopImage from '../../images/articles/PO0131005_WF_BRAND_2HFY24_ISF_SepUpdate14_LP_1164x584.jpg';

import { fireTag } from '../../libs/analytics.js';

const PastFuture = ({
    handleEvent,
    closeExitOverlay,
    addExitClickListeners,
    modalOverlay,
}) => {

    const [enableScrollGA, setEnableScrollGA] = useState(false);
    const [shouldBeInert, setShouldBeInert] = useState(false);
    const [gridVisible, setGridVisible] = useState(false);
    const heroOGImage = 'PO0131005_WF_BRAND_2HFY24_ISF_SepUpdate14_LP_ogimage.jpg';

    const toggleInert = () => {
        setShouldBeInert(!shouldBeInert)
    }

    const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				fireTag('A2',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}

	useEffect(() => {
		linkDisclosures();
		addExitClickListeners();
	}, []); // empty array says only use this effect once

    let mastheadImage = window.innerWidth < 768 ? heroMobileImage : heroDesktopImage;

    return (
		<>
			<Helmet>
				<title>From an industrial past to a sustainable future</title>
				<meta
					name="description"
					content="An old power plant is transformed into a mixed-use development that embraces sustainability and financial innovation."
				/>
				<meta property="og:title" content="From an industrial past to a sustainable future"/>
				<meta
					property="og:description"
					content="An old power plant is transformed into a mixed-use development that embraces sustainability and financial innovation."
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/${heroOGImage}`}/>

				<meta property="twitter:title" content="From an industrial past to a sustainable future"/>
				<meta
					property="twitter:description"
					content="An old power plant is transformed into a mixed-use development that embraces sustainability and financial innovation."
				/>
				i
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}

			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>

			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}


			<main className="flex-container">

				<div className="flex-row">
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
                        From an industrial past to a sustainable future
                        </h1>
						<h2 className="summary">
                        An old power plant is transformed into a mixed-use development that embraces sustainability and financial innovation.
                        </h2>
					</div>

				</div>

				<div className="flex-row full-width-md">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="Aerial view of The Battery, a former power plant converted into a mixed-use, multifamily apartment building"/>
					</div>
				</div>
                
				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro info-graphic">
                    <div className="by-line">
							<p>By Kelly A. Souza, <span>managing director, sustainable finance and advisory at Wells Fargo, Corporate & Investment Banking</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>September 19, 2024</p>
							</div>
							<div>
								<p>3-minute read</p>
							</div>
						</div>
						<p>The commercial real estate industry is often looking for ways to acknowledge the past while designing for the future. Some transformations can seem unconventional, like the <a onClick={()=> fireTag('A1','high line')} target="_blank" href="https://www.thehighline.org/about/" rel="noreferrer">High Line</a> in New York that turned an abandoned railway into an urban park, or <a onClick={()=> fireTag('A1','church brew works')} target="_blank" href="https://churchbrew.com/history/" rel="noreferrer">Church Brew Works</a> in Pittsburgh, which converted an old church into a brewery. These novel redevelopment projects inspire developers and investors to think differently about urban restoration.</p>
                        <p>
                        In December 2023, Wells Fargo led an innovative transaction with <a onClick={()=> fireTag('A1','lubert-adler')} target="_blank" href="https://lubertadler.com/properties/the-battery/" rel="noreferrer">Lubert-Adler</a>, a real estate firm, to support the redevelopment of an old power plant. The former Philadelphia Electric Company power plant along the Delaware River in Philadelphia could generate <a onClick={()=> fireTag('A1','almost half')} target="_blank" href="http://www.thebatteryphl.com/about/" rel="noreferrer">almost half</a> of the city’s electric supply a century ago. Today, <a onClick={()=> fireTag('A1','the battery')} target="_blank" href="http://www.thebatteryphl.com/" rel="noreferrer">The Battery</a> is a mixed-use, multifamily apartment building that incorporates the plant’s original architecture while creating modern living spaces with energy-efficient systems and smart technology.     
                        </p>
                        <h2 className="subhead" style={{marginTop: '1rem'}}>
                        Financial collaborations advance sustainability 
						</h2>
						<p>
                        The Battery’s financing structure is as innovative as the project itself. Wells Fargo’s Real Estate Banking team provided a $107.9 million construction loan and the Community Lending and Investment team made a $27.9 million federal <a onClick={()=> fireTag('A1','historic tax credit')} target="_blank" href="https://pahistoricpreservation.com/historic-tax-credits-work-delaware-station-the-philadelphia-electric-company/" rel="noreferrer">historic tax credit</a> investment. In addition, the lending team worked with a third-party lender and consented to the use of $26.6 million of <a onClick={()=> fireTag('A1','commercial property assessed clean energy')} target="_blank" href="https://www.epa.gov/statelocalenergy/commercial-property-assessed-clean-energy" rel="noreferrer">Commercial Property Assessed Clean Energy</a>, or C-PACE, to help improve the building’s energy efficiency.
                        </p>
                        <p>
                        C-PACE is a financing tool that allows property owners to cover the upfront cost of energy or resilience upgrades. This includes financing for sustainability enhancements, such as grid resiliency projects, electric vehicle (EV) charging infrastructure, stormwater management, environmental remediation, or indoor air quality improvements. The voluntary tax assessment placed on the property is paid off gradually through property taxes.
                        </p>
					</div>
				</div>
                <div className="flex-row full-width">
					<div className="flex-row text-center">
						<div className="flex-col-md-8 flex-col-sm-12 text-center content-box">
							<div className="content-header bulleted">
								<h2 className="content-title bulleted">Key features of C-PACE financing</h2>
							</div>
							<div className="inner-content bulleted">
								<div className="content">
									<div>
										<ul>
											<li className="offset-title">Provides building property owners with upfront funding for clean energy projects.</li>
											<li className="offset-title">Uses property liens so property owners can repay the funding on their property taxes over the long term.</li>
											<li className="offset-title">Allows for transferability of the assessment upon sale of the property.</li>
										</ul>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
                <div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center">
						<p>
                        The Battery’s sustainability features include onsite EV charging, low volatile organic compound apartment finishes, energy-efficient appliances, low-flow bathroom fixtures, low emissivity windows to reflect heat and reduce energy loss, and a rubber roof membrane that minimizes the <a onClick={()=> fireTag('A1','heat island effect')} target="_blank" href="https://www.epa.gov/heatislands#:~:text=1%202%203%204,as%20forests%20and%20water%20bodies." rel="noreferrer">heat island effect</a>. With these enhancements, the Philadelphia Energy Authority expects the project’s modeled energy use to be <a onClick={()=> fireTag('A1','29% lower')} target="_blank" href="https://philaenergy.org/lubert-adler-northbridge-esg-llc-close-25-6mm-deal-the-third-largest-in-pennsylvania/" rel="noreferrer">29% lower</a> than the city’s building energy code. 
						</p>
						<h2 className="subhead">
                        New financing models set a precedent
                        </h2>
                        <p>
                        The deal with Lubert-Adler was recognized as one of the <a onClick={()=> fireTag('A1','innovative deals of the year')} target="_blank" href="https://www.pacenation.org/pacenation-announces-2024-pacesetters-and-pace-champion-of-the-year-award-winners/" rel="noreferrer">innovative deals of the year</a> by PACENation, the national membership organization for PACE financing. It is also the first transaction providing C-PACE consent for Wells Fargo’s Commercial Real Estate business — one of the first such transactions for a large commercial bank — and the third largest C-PACE financing in Pennsylvania at the time of closing. 						
                        </p>
                        <p>
                        Transactions like this one require careful navigation and coordination among multiple stakeholders. The project’s success can serve as a replicable model for future transactions that encourages cross-sector collaboration to advance sustainability and serve modern communities. 						
                        </p>
					</div>
				</div>
			</main>


			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>

			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}
		</>
    );

};

export default withRouter(PastFuture);



